import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import axios from "axios";

const fetchAllOrders = async (token, page, status) => {
  const params = new URLSearchParams({ page: String(page), limit: "20" });
  if (status && status !== "all") params.set("status", status);

  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/orders?${params}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const useAllOrders = (page = 1, status = "all") => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useQuery(
    ["allOrders", page, status],
    () => fetchAllOrders(token, page, status),
    { enabled: !!token && isLoggedIn, keepPreviousData: true }
  );
};

export default useAllOrders;
